module.exports = __webpack_public_path__ + "static/img/fenzu.4c56788.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/fenzu.png
// module id = Ussl
// module chunks = 24